import qs from 'qs';
import { setWamazingAfidToCookie } from '../utils/trackingHelper';

export default function trackAffiliate() {
  const query = window.location.search.replace('?', '');
  const params = qs.parse(query);
  if (params.wamazing_afid) {
    setWamazingAfidToCookie(params.wamazing_afid);
  }
}
